export class VueGMDSS {
  constructor () {
    this.name = 'VueGMDSS'
    this.file = ''
    this.file2 = ''
    this.file3 = ''
    this.video = []
    // 获取所有船
    this.getShip = ''
    // 学习项目
    this.statutesUnread = ''
    this.assessUnread = ''
    this.basicsUnread = []
    this.Basics = ''
    this.Basics2 = ''
    this.statutes = ''
    this.statutes2 = ''
    // likefr new 20220323
    this.requiredData = {
      statutesUnread: 0,
      basicsUnread: 0
    }
    this.optionsList = []
    this.exce = ''
    this.station_id = 0 // 当前岗位id
    // 当前用户必学视频
    this.videoReadList = []
    // 获取必学视频个数
    this.mustLearnVideo = 0
    this.model = 1
    // 用户token
    this.token = ''
    this.authority = ''
    this.branch = ''
    this.user_info = null
    // this.loginURL = 'http://127.0.0.1/login/#/'
    // this.loginURL = 'http://localhost:3005/#/'
    this.loginURL = 'http://www.xmhgapi.com/train_login'
    // 学习时长
    this.station = ''
    this.learn_time = 0
    this.learnList = []
    // 首次阅读书本
    this.is_enter = true
    // 职位列表
    this.stationList = []
    // 部门列表
    this.branchList = []
    // 菜单列表
    this.menuList = []
    this.shuxin = '127.0.0.1'
    // 视频路径
    this.videoUrl = 'http://www.xmhgapi.com/train_video/'
    // 工具路径
    this.toolUrl = 'http://www.xmhgapi.com/train_tool/'
    // 文档路径
    this.bookUrl = 'http://www.xmhgapi.com/train_book/'
    // 第一次登录要看的文档路径
    this.loginBook = 'http://www.xmhgapi.com/train_loginBook/'
    // this.bookUrl = 'http://www.xmhgapi.com/'
    this.iconUrl = 'http://www.xmhgapi.com/train_userImg/'
    // this.iconUrl = 'http://www.xmhgapi.com/'
    this.examineList = [
      {
        id: 1,
        name: '三副考试'
      },
      {
        id: 2,
        name: '二副考试'
      },
      {
        id: 3,
        name: '大副考试'
      }
    ]
    this.learnType = [
      {
        id: 1,
        type: '基础业务'
      },
      {
        id: 2,
        type: '考核'
      },
      {
        id: 3,
        type: '法规'
      }
    ]
    this.exportList = []
    this.dialogVisible = false
  }
  getName (list, id, objName) {
    for (let i in list) {
      if (list[i].id === id) {
        return list[i][objName]
      }
    }
  }
  getUnreadByType (type) {
    let learnStr = this.user_info
    let learnObj = this.stringToJson(learnStr.study_record)
    let learnList = this.learnList
    let list = []
    for (let i in learnList) {
      let learn = learnList[i]
      let id = learn.id
      if (learn.type !== type) {
        continue
      }
      let job = learn.job
      if (job === 0 && learn.exclude != null) {
        let exclude = learn.exclude
        if (exclude.indexOf(learnStr.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
          continue
        }
      }
      let data = learnObj[id]
      if (data) {
        if (data.isOver) {
          continue
        }
      }
      list.push(learn)
    }
    console.log('list', list.length, learnObj)
    return list
  }
  stringToJson (data) {
    if (!data) {
      console.log('1111111111', data)
      return {}
    }
    if (['', 'null'].includes(data)) {
      console.log('2222222222')
      return {}
    }
    console.log('3333333333')
    return JSON.parse(data)
  }
  compareMneuId (menuId) {
    if (menuId !== this.learn_menu && this.learn_menu > 0) {
      return false
    }
    return true
  }
  // updateStudyRecord (newRecord) {
  //   this.user_info.study_record = newRecord
  // }
  // 根据id获取书的阅读记录
  getIsRead (bookId) {
    let studyRecord = this.user_info.study_record
    let obj = this.stringToJson(studyRecord)
    if (!obj) {
      return null
    }
    if (!obj[bookId]) {
      return null
    }
    return obj[bookId]
  }
  // 分级获取菜单
  getLevel () {
    let list = this.menuList
    let arr = []
    for (let i in list) {
      let obj = list[i]
      let id = obj.id
      let fatherId = obj.father_id
      let res = this.getPermission(obj.main_id)
      if (!res) {
        continue
      }
      if (!fatherId) {
        arr.push(obj)
      }
      let array = this.children(id)
      if (array.length) {
        obj.children = array
      }
    }
    return arr
  }
  getCount (list) {
    let amount = list.length
    for (let i in list) {
      let obj = list[i]
      if (obj.children) {
        amount += obj.children.length
      }
    }
    return amount
  }
  children (id) {
    let list = this.menuList
    let arr = []
    for (let i in list) {
      let obj = list[i]
      let fatherId = obj.father_id
      if (fatherId === id) {
        arr.push(obj)
      }
    }
    return arr
  }
  // 判断用户有没有权限
  getPermission (mainId) {
    let list = this.user_info.mean_limit
    let res = list.indexOf(mainId)
    if (res > -1) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/gmdss/index.js